import React from 'react';
import { AlertCircle, CheckCircle, Info, X } from 'lucide-react';

const AlertComponent = ({ alertMessage, clearAlert }) => (
  alertMessage && (
    <div className={`fixed top-4 left-4 right-4 sm:right-4 sm:left-auto z-50 max-w-md mx-auto sm:mx-0 p-4 rounded-lg shadow-lg border-l-4 ${alertMessage.type === 'error' ? 'bg-red-50 border-red-500' :
      alertMessage.type === 'duplicate' ? 'bg-orange-50 border-orange-500' :
        alertMessage.type === 'success' ? 'bg-green-50 border-green-500' :
          'bg-blue-50 border-blue-500'
      }`}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          {alertMessage.type === 'error' && <AlertCircle className="text-red-500" size={20} />}
          {alertMessage.type === 'duplicate' && <AlertCircle className="text-orange-500" size={20} />}
          {alertMessage.type === 'success' && <CheckCircle className="text-green-500" size={20} />}
          {alertMessage.type === 'info' && <Info className="text-blue-500" size={20} />}
        </div>
        <div className="ml-3 flex-1">
          <p className={`text-sm font-medium ${alertMessage.type === 'error' ? 'text-red-800' :
            alertMessage.type === 'duplicate' ? 'text-orange-800' :
              alertMessage.type === 'success' ? 'text-green-800' :
                'text-blue-800'
            }`}>
            {alertMessage.message}
          </p>
          {alertMessage.barcode && (
            <p className="text-xs font-mono mt-1 text-gray-600 break-all">
              Barcode: {alertMessage.barcode}
            </p>
          )}
          {alertMessage.existingRack && (
            <p className="text-xs mt-1 text-gray-600">
              Currently in rack: <span className="font-mono">{alertMessage.existingRack}</span>
            </p>
          )}
        </div>
        <button
          onClick={clearAlert}
          className="flex-shrink-0 ml-2 hover:bg-gray-100 rounded p-1"
        >
          <X size={16} className="text-gray-400 hover:text-gray-600" />
        </button>
      </div>
    </div>
  )
);

export default AlertComponent;